import axios from '../../axios'

export const getEnumListByCode = (data) => {
  return axios({
    url: '/common/getEnumListByCode',
    method: 'post',
    data
  })
}
//获取部门树
export const getDeptTree = (data) => {
  return axios({
    url: '/common/getDeptTree',
    method: 'post',
    data
  })
}
//获取部门列表
export const getDeptList = (data) => {
  return axios({
    url: '/common/getDeptList',
    method: 'post',
    data
  })
}

// 在线查看文件
export const viewFile = (data) => {
  return axios({
    url: '/common/viewFile',
    method: 'post',
    data,
  })
}

//获取平台分类
export const getPlatformList = (data) => {
  return axios({
    url: '/common/getPlatformList',
    method: 'post',
    data,
  })
}

//获取用户列表
export const getUserList = (data) => {
  return axios({
    url: '/common/getUserList',
    method: 'post',
    data,
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/commonJS/commonJS.js